import React from 'react';
import { Skeleton } from 'antd';

export default function LoaderSkeleton() {
  return <Skeleton active />;
}
